import styled from "styled-components";

export const BoxContainer = styled.div`
  min-height: 300px;
`;

export const NoDataContainer = styled.div`
  margin: 0px auto;
  color: white;
  padding-top: 30px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UpdateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  transition: all 0.2s;
  border-radius: 6px;
  padding: 0.4rem 1rem;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid;

  background-color: transparent;
  border-color: #d1d5db;
  color: #6b7280;

  ${(props) =>
		props.hasChanges &&
		!props.disabled &&
		`
    background-color: #10B981;
    border-color: #10B981;
    color: white;
    
    &:hover {
      background-color: #059669;
      border-color: #059669;
    }
    
    &:active {
      background-color: #047857;
      border-color: #047857;
    }
  `}

  ${(props) =>
		props.disabled &&
		`
    opacity: 0.65;
    cursor: not-allowed;
    background-color: ${props.hasChanges ? "#10B981" : "transparent"};
    border-color: ${props.hasChanges ? "#10B981" : "#D1D5DB"};
    color: ${props.hasChanges ? "white" : "#6B7280"};
  `}
  
  &:not(:disabled):hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
`;
